// extracted by mini-css-extract-plugin
module.exports = {"notif":"IconNotif-module--notif--1-JCZ","badge":"IconNotif-module--badge--YnJY7"};